export enum TableStyleConfig {
  MIN_WIDTH = 62,
}

export enum TableSortConfig {
  DESC = 'desc',
  ASC = 'asc'
}

export enum NzTableSortConfig {
  DESCEND = 'descend',
  ASCEND = 'ascend'
}
